// import { X } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogPortal,
    DialogOverlay,
} from "@/components/ui/dialog"; // Sesuaikan path ini dengan folder UI kamu

interface ClothingSizeModalProps {
    isOpen: boolean;
    onOpenChange: (open: boolean) => void;
}

const ClothingSizeModal = ({ isOpen, onOpenChange }: ClothingSizeModalProps) => {
    const { t } = useTranslation('registration');
    const title = t('registration.labels.clothing_size_table_title');
    const imageSrc = "/ukuran-baju.jpg";
    return (
        <Dialog open={isOpen} onOpenChange={onOpenChange}>
            <DialogPortal>
                <DialogOverlay className="fixed inset-0 z-[100] bg-black/10 backdrop-blur-sm" />
                <DialogContent className="fixed left-[50%] top-[50%] z-[101] w-[90vw] max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 border-none bg-background p-6 shadow-xl duration-200 dark:bg-gray-800 rounded-xl outline-none">

                    {/* Tombol Close Pojok Kanan Atas */}
                    <button
                        type="button"
                        onClick={() => onOpenChange(false)}
                        className="absolute right-4 top-4 rounded-sm opacity-70 transition-opacity hover:opacity-100 focus:outline-none dark:text-gray-400"
                    >
                        {/* <X className="h-5 w-5" /> */}
                        {/* <span className="sr-only">Close</span> */}
                    </button>

                    <DialogHeader>
                        <DialogTitle className="text-lg font-bold text-foreground dark:text-white pr-8">
                            {title}
                        </DialogTitle>
                    </DialogHeader>

                    <div className="mt-4 relative overflow-hidden rounded-lg border dark:border-gray-700 bg-white p-2">
                        <img
                            src={imageSrc}
                            alt="Size Chart Guide"
                            className="w-full h-auto object-contain max-h-[65vh]"
                        />
                    </div>
                </DialogContent>
            </DialogPortal>
        </Dialog>
    );
};

export default ClothingSizeModal;